import { EMPTY_HTML_TAG_REGEX } from './regex.utils';

export const getPluralString = (
  singularString: string,
  numberOfOccurrences: number,
) => `${singularString}${numberOfOccurrences > 1 ? 's' : ''}`;

export const generateObjectId = () => {
  const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
  const randomBytes = 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () =>
    ((Math.random() * 16) | 0).toString(16),
  );
  return timestamp + randomBytes;
};

export const containsOnlyEmptyHTMLTags = (input: string) => {
  // Remove all empty HTML tags from the input string
  const strippedString = input.replace(EMPTY_HTML_TAG_REGEX, '').trim();
  return strippedString === '';
};

export const getChangedStringPlaceholder = (template: string, data: object) => {
  return template.replace(/{{(.*?)}}/g, (_, key) => {
    return data[key] !== undefined ? data[key] : `{{${key}}}`;
  });
};
